const { getApiUrl, CLIENT_ID } = require("./signupConfig")

const SUBMIT_PROVIDER_INTEREST_MUTATION = `
  mutation submitProviderInterest(
    $captcha: String!
    $name: String!
    $email: String!
    $businessName: String
    $companyRegistrationNumber: String
    $country: String!
    $phoneNumber: String
    $pageRoute: String
    $userAgent: String
    $referrer: String
  ) {
    submitProviderInterest(
      SubmitProviderInterestInput: {
        registerProvider: true
        captcha: $captcha
        name: $name
        email: $email
        businessName: $businessName
        companyRegistrationNumber: $companyRegistrationNumber
        country: $country
        phoneNumber: $phoneNumber
        pageRoute: $pageRoute
        userAgent: $userAgent
        referrer: $referrer
      }
    ) {
      success
      message
    }
  }
`

async function submitProviderInterest(variables, { fetchImpl, apiUrl } = {}) {
  const fetchFn = fetchImpl || (typeof fetch !== "undefined" ? fetch : null)
  if (!fetchFn) {
    throw new Error("fetch is not available")
  }

  const response = await fetchFn(apiUrl || getApiUrl(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      clientid: CLIENT_ID,
    },
    body: JSON.stringify({
      query: SUBMIT_PROVIDER_INTEREST_MUTATION,
      variables,
      operationName: "submitProviderInterest",
    }),
  })

  const payload = await response.json()
  if (!response.ok) {
    throw new Error("Request failed")
  }
  if (payload.errors?.length) {
    throw new Error(payload.errors[0]?.message || "Request failed")
  }

  const result = payload.data?.submitProviderInterest
  if (!result?.success) {
    throw new Error(result?.message || "Something went wrong. Please try again.")
  }
  return result
}

module.exports = {
  SUBMIT_PROVIDER_INTEREST_MUTATION,
  submitProviderInterest,
}
